import React from 'react';
import { Award, GraduationCap, Sparkles, Users, BookOpen } from 'lucide-react';

// Slim authority strip — appears directly under the Hero to establish
// Teacher Kalah's credibility before the visitor scrolls further.

const items = [
  { icon: Sparkles, label: '20+ Years of Teaching Experience' },
  { icon: GraduationCap, label: "Master's in Early Childhood Education" },
  { icon: Award, label: 'Montessori Trainer' },
  { icon: BookOpen, label: 'Early Literacy Specialist' },
  { icon: Users, label: 'Teacher Trainer' }
];

const AuthorityStrip = () => {
  return (
    <section
      aria-label="Founder credentials"
      data-testid="authority-strip"
      className="bg-gradient-to-r from-slate-50 via-white to-slate-50 border-y border-slate-100"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-7">
        <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 sm:gap-x-8 text-center">
          {items.map((it, idx) => {
            const Icon = it.icon;
            return (
              <li
                key={idx}
                className="flex items-center gap-2 text-xs sm:text-sm font-semibold text-gray-700"
              >
                <Icon className="h-4 w-4 text-[#3B4BA0] flex-shrink-0" />
                <span>{it.label}</span>
                {idx < items.length - 1 && (
                  <span
                    aria-hidden="true"
                    className="hidden lg:inline-block ml-6 w-1 h-1 rounded-full bg-slate-300"
                  />
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default AuthorityStrip;
